import { makeStyles } from '@material-ui/core/styles'
import { Height } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  container: {
    margin: '40px 40px 24px'
  },
  headerWrapper: {
    margin: '10px 40px 24px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subHeadingWrapper: {
    display: 'flex',
    margin: '0px 20px'
  },
  selectRoot: {
    width: '80px',
  },
  graphTitle: {
    color: '#335977',
    fontSize: '20px',
    fontWeight: '600'
  },
  infoIcon: {
    fontSize: '14px',
    cursor: 'pointer',
    margin: '0px 5px',
    color: '#707070'
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  infoPopoverPaper: {
    width: '500px'
  },
  infoPopover: {
    fontSize: '12px'
  },
  toggleWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 40,
    marginBottom: 20
  },
  switchWrapper: {
    display: "flex", 
    alignItems: "center", 
    gap: 10
  },
  hintWrapper: {
    background: "white",
    padding: "8px 10px",
    borderRadius: '4px',
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    fontSize: '12px'
  }
}))

export default useStyles